import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const forgotPassword = (username) => {
  return axios.post(`/api/v1/auth/forgotpassword`, {
    username,
  });
};

export const useForgotPassword = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation(forgotPassword, {
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: 'Reset information sent successfully',
      });
    },
    ...config,
  });
};
